<!--
<edit-dialog title="Klant aanpassen" :event="save" @close="close" @open="open" :loading="loading">
    <fields v-model="editCustomer" :validations="$v.editCustomer" />

    <template v-slot:button="{ on, attrs }">
         <v-btn text v-bind="attrs"
                v-on="on">
             Custom button <v-icon small>mdi-plus</v-icon>
         </v-btn>
    </template>
</edit-dialog>
-->
<template>
    <v-dialog v-model="dialog" :width="width" :transition="false" :fullscreen="fullscreen" persistent scrollable :retain-focus="retainFocus">
        <template v-slot:activator="{ on, attrs }">
            <slot name="button" v-bind="{ on, attrs }">
                <v-btn icon color="primary" v-bind="attrs"
                       v-on="on"><v-icon>mdi-pencil</v-icon></v-btn>
            </slot>
        </template>
        <v-card>
            <v-toolbar
                flat
                dark
                color="primary"
                max-height="64"
            >
                <v-toolbar-title>{{ title }}</v-toolbar-title>

            </v-toolbar>
            <v-card-text v-if="!loading && dialog" class="pt-4">
                <slot></slot>
            </v-card-text>
            <v-card-text v-if="loading" class="text-center">
                <v-icon color="primary" class="ma-4">mdi-loading mdi-spin</v-icon>
            </v-card-text>
            <v-card-actions>
                <v-btn color="secondary" outlined @click="close">Annuleren</v-btn>
                <v-spacer></v-spacer>
                <event-button :disabled="loading" color="primary" :event="save">{{ sendButtonText }}</event-button>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import EventButton from "@/components/General/Button/EventButton";

export default {
    components: {
        EventButton,
    },
    props: {
        title: {
            required: true,
            type: String,
        },
        event: {
            required: true,
        },
        width: {
            required: false,
            type: Number,
            default: 800,
        },
        fullscreen: {
            type: Boolean,
            default: false,
        },
        loading: {
            required: false,
            type: Boolean,
            default: false,
        },
        sendButtonText:{
            required: false,
            type: String,
            default: 'Opslaan',
        },
        forceState: {
            type: Boolean,
            required: false,
            default: null,
        },
        // Documentation: https://v2.vuetifyjs.com/en/api/v-dialog/#props-retain-focus
        retainFocus: {
            type: Boolean,
            required: false,
            default: true,
        }
    },
    data() {
        return {
            dialog: false,
        }
    },
    watch: {
        forceState(state) {
            if (state !== null) {
                this.dialog = state;
            }
        },
        dialog(visible) {
            if (visible) {
                this.$emit('open');
            } else {
                this.$emit('close');
            }
        }
    },
    methods: {
        async save() {
            let response = this.event();

            if (response && response.then && typeof response.then === 'function') {
                return response.then(() => {
                    this.close();
                });
            }

            return Promise.resolve();
        },
        close() {
            this.dialog = false;
            this.$emit('close');
        },
    },
}
</script>
